// extracted by mini-css-extract-plugin
module.exports = {"containerComponent":"container-component_containerComponent__b_9_c","heroPlaceholder":"container-component_heroPlaceholder__LO98X"};